module.exports = __webpack_public_path__ + "dashboard/img/search.47a5e8bf3606f91a99fd39067628d1e7.svg";